import {
  MdOutlineRocketLaunch,
  MdOutlineSwapHoriz,
  MdOutlineAutoAwesome,
  MdOutlineAttachMoney,
  MdOutlineAutoGraph,
  MdOutlinePrecisionManufacturing,
  MdOutlineShare,
  MdOutlineCelebration,
} from "react-icons/md";
import styles from "../../../styles/Components/faq/GeneralQuestions.module.css";
import { HiOutlineRocketLaunch } from "react-icons/hi2";

// const questions = [
//   "AI-powered platform",
//   "Unique features",
//   "Plans comparison",
//   "AI accuracy",
//   "Automated trading",
//   "Other assets",
//   "Two portfolios",
//   "Real money",
//   "Social media",
// ];
const questions = [
  {
    label: "Exchange?",
    title: "CryptoCrispy: Exchange?",
    icon: <MdOutlineSwapHoriz />,
  },
  {
    label: "Uniqueness",
    title: "CryptoCrispy's Uniqueness",
    icon: <MdOutlineAutoAwesome />,
  },
  {
    label: "Spot / Futures",
    title: "Spot and Futures?",
    icon: <MdOutlineAttachMoney />,
  },
  {
    label: "Trading Data",
    title: "Data for Trading",
    icon: <MdOutlineAutoGraph />,
  },
  // {
  //   label: "VIP Signals",
  //   title: "VIP Signals Access",
  //   icon: <MdOutlineRocketLaunch />,
  // },
  {
    label: "Automation",
    title: "Automated Features",
    icon: <MdOutlinePrecisionManufacturing />,
  },
  {
    label: "Social",
    title: "Social Media Links",
    icon: <MdOutlineShare />,
  },
  {
    label: "Is it Free?",
    title: "Platform: FREE?",
    icon: <MdOutlineCelebration />,
  },
];

const QuickAccessMenu = () => {
  const handleJump = (event, index) => {
    event.preventDefault();

    const faqItem = document.getElementById(`q${index}`);
    const questions = document.getElementById("common-questions");
    if (!faqItem) return;

    // Remove highlight from any previously highlighted question
    const previousHighlight = questions?.querySelector(
      `li.${styles.faqHighlight}`,
    );

    previousHighlight?.classList.remove(styles.faqHighlight);

    faqItem.scrollIntoView({ behavior: "smooth" });
    faqItem.classList.add(styles.faqHighlight);
    if (handleJump._t) window.clearTimeout(handleJump._t);
    handleJump._t = window.setTimeout(() => {
      faqItem.classList.remove(styles.faqHighlight);
    }, 3000);
  };

  return (
    <div className={styles.quickAccess}>
      <div className={styles.quickAccessHeader}>
        <span className={styles.quickAccessBadge}>
          <HiOutlineRocketLaunch />
        </span>
        <div className={styles.quickAccessTitles}>
          <h3 className={styles.quickAccessTitle}>Quick Access</h3>
          <p className={styles.quickAccessSubtitle}>
            Jump to any question below
          </p>
        </div>
      </div>
      <div className={styles.quickAccessGrid}>
        {questions.map((question, index) => (
          <a
            key={index}
            href={`#q${index - 1}`}
            title={question.title}
            onClick={(event) => handleJump(event, index)}
            className={styles.quickChip}
          >
            <span className={styles.quickChipIndex}>{index + 1}</span>
            <span className={styles.quickChipIcon}>{question.icon}</span>
            <span className={styles.quickChipLabel}>{question.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default QuickAccessMenu;
